import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Bill } from '../models/bill';


@Injectable({
    providedIn: 'root'
})
export class BillService {
 /*   url = "api/bills";*/
    private apiUrl = 'api/Bill'; 


    constructor(private http: HttpClient) { }

    getBillsByMatter(actionId: string): Observable<Bill[]> {
        return this.http.get<Bill[]>(`${this.apiUrl}/bills/${actionId}`);
    }
}

